( function () {
	'use strict';

	let BILLING_KEY = 'yearly';

	function setBillingState( billing ) {
		BILLING_KEY = billing === 'monthly' ? 'monthly' : 'yearly';

		document
			.querySelectorAll( '[data-plans-billing-toggle]' )
			.forEach( function ( root ) {
				const switchButton = root.querySelector(
					'[data-billing-switch]'
				);
				const monthlyLabel = root.querySelector(
					'[data-billing-label="monthly"]'
				);
				const yearlyLabel = root.querySelector(
					'[data-billing-label="yearly"]'
				);

				if ( switchButton ) {
					switchButton.classList.toggle(
						'is-yearly',
						BILLING_KEY === 'yearly'
					);
					switchButton.setAttribute(
						'aria-pressed',
						BILLING_KEY === 'yearly' ? 'true' : 'false'
					);
				}

				if ( monthlyLabel ) {
					monthlyLabel.classList.toggle(
						'is-active',
						BILLING_KEY === 'monthly'
					);
				}

				if ( yearlyLabel ) {
					yearlyLabel.classList.toggle(
						'is-active',
						BILLING_KEY === 'yearly'
					);
				}
			} );

		document
			.querySelectorAll( '[data-plans-pricing]' )
			.forEach( function ( root ) {
				root.querySelectorAll( '[data-billing-value]' ).forEach(
					function ( el ) {
						el.classList.toggle(
							'is-hidden',
							el.getAttribute( 'data-billing-value' ) !==
								BILLING_KEY
						);
					}
				);

				root.querySelectorAll( '[data-billing-suffix]' ).forEach(
					function ( el ) {
						el.classList.toggle(
							'is-hidden',
							el.getAttribute( 'data-billing-suffix' ) !==
								BILLING_KEY
						);
					}
				);
			} );
	}

	function bindSwitches() {
		document
			.querySelectorAll( '[data-billing-switch]' )
			.forEach( function ( button ) {
				if ( button.dataset.plansBound ) {
					return;
				}

				button.dataset.plansBound = 'true';
				button.addEventListener( 'click', function () {
					setBillingState(
						BILLING_KEY === 'yearly' ? 'monthly' : 'yearly'
					);
				} );
			} );
	}

	function init() {
		const hero = document.querySelector( '[data-plans-hero]' );
		const pricing = document.querySelector( '[data-plans-pricing]' );
		let initial = 'yearly';

		if ( hero && hero.dataset.defaultBilling ) {
			initial = hero.dataset.defaultBilling;
		} else if ( pricing && pricing.dataset.defaultBilling ) {
			initial = pricing.dataset.defaultBilling;
		}

		bindSwitches();
		setBillingState( initial );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init, { once: true } );
	} else {
		init();
	}
} )();
